class Overlay {
  constructor() {
    this.initialise();
  }

  initialise() {
    console.log('Overlay initialised');
    document.body.classList.add('overflow-hidden');

    this.overlay = document.createElement('div');
    this.overlay.setAttribute('data-overlay', '');
    this.overlay.className =
      'group data-overlay fixed inset-0 w-full h-full flex items-center justify-center bg-black cursor-pointer z-30 transition-all opacity-0 invisible delay-300 active:delay-[0ms] active:visible';
    this.overlay.innerHTML = `
      <svg class="w-10 h-10 text-white animate-spin opacity-0 invisible group-loading:opacity-100 group-loading:visible" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <g fill="currentColor"><g><path d="M24 47a23 23 0 1 1 23-23 23.025 23.025 0 0 1-23 23zm0-42a19 19 0 1 0 19 19A19.021 19.021 0 0 0 24 5z" opacity=".4"></path><path d="M47 24h-4A19.021 19.021 0 0 0 24 5V1a23.025 23.025 0 0 1 23 23z"></path></g></g>
      </svg>
    `;

    document.body.appendChild(this.overlay);

    this.overlay.addEventListener('click', this.handleClick.bind(this));

    setTimeout(() => {
      this.overlay.classList.add('active');
    }, 10);
  }

  handleClick(e) {
    if (e.target.closest('[data-overlay]') === null) return;

    this.close();

    if (window.drawer) {
      window.drawers.activeDrawer = false;
    }

    if (window.popup) {
      window.popup.close();
    }
  }

  close() {
    this.overlay.classList.remove('active');

    document.body.classList.remove('overflow-hidden');

    this.overlay.addEventListener(
      'transitionend',
      () => {
        this.destroy();
      },
      { once: true }
    );
  }

  destroy() {
    this.overlay.remove();

    window.overlay = false;
  }

  get el() {
    return this.overlay;
  }

  set loading(val) {
    this.overlay.classList.toggle('loading', val);
  }
}

export default Overlay;


class Drawers extends HTMLElement {
  constructor() {
    super();

    window.drawers = this;

    this._activeDrawer = false;

    this.selectors = {
      close: '[data-drawer-close]',
      overlay: '[data-overlay]',
      trigger: '[data-drawer-trigger]'
    };

    this.els = {
      body: document.body,
      drawers: this,
      overlay: this.querySelector(this.selectors.overlay)
    };

    this.initialise();
  }

  initialise() {
    document.addEventListener('click', this.handleClick.bind(this));

    this.triggerKeys = [
      ...new Set(
        Array.from(document.querySelectorAll('[data-drawer-trigger]')).map(
          (el) => el.getAttribute('data-drawer-trigger')
        )
      )
    ];

    this.availableDrawers = Array.from(
      this.querySelectorAll('[data-drawer-key]')
    ).map((el) => el.getAttribute('data-drawer-key'));
  }

  /**
   * Click handler to close the popup
   *
   * @param {Event} e
   */
  handleClick(e) {
    const eventType = this.getEventType(e);

    if (eventType === 'TRIGGER') {
      const triggerEl = e.target.closest(this.selectors.trigger);
      const drawerKey = triggerEl.dataset.drawerTrigger;

      this.activeDrawer = drawerKey;
    } else if (eventType === 'CLOSE') {
      this.activeDrawer = false;

      window.overlay.close();
    }
  }

  /**
   * Get the event type based on selectors
   *
   * @param {Event} e
   * @returns String
   */
  getEventType(e) {
    if (e.target.closest(this.selectors.trigger) !== null) {
      return 'TRIGGER';
    }

    if (e.target.closest(this.selectors.close) !== null) {
      return 'CLOSE';
    }

    return 'UNKNOWN';
  }

  closeActiveDrawer() {
    document
      .querySelector(`[data-drawer-key="${this.activeDrawer}"]`)
      .classList.remove('active');
  }

  get activeDrawer() {
    return this._activeDrawer;
  }

  set activeDrawer(key) {
    window.drawer = key;

    /**
     * If opening drawer from popup, close popup
     */
    if (window.popup) {
      window.popup.close();
    }

    if (key) {
      /**
       * If drawer doesn't exist, stop
       */
      if (document.querySelector(`[data-drawer-key="${key}"]`) === null) {
        // eslint-disable-next-line no-console
        console.log(`Drawer '${key}' not found`);

        return;
      }

      /**
       * If overlay doesn't already exist, create one
       */
      if (!window.overlay) {
        console.log('Creating overlay');
        window.overlay = new Overlay();
      }

      /**
       * If a drawer is alerady open, close it otherwise open requested drawer
       */
      if (this.activeDrawer) {
        document
          .querySelector(`[data-drawer-key="${this.activeDrawer}"]`)
          .classList.remove('active');

        if (this.activeDrawer) {
          setTimeout(() => {
            document
              .querySelector(`[data-drawer-key="${key}"]`)
              .classList.add('active');
          }, 300);
        }
      } else {
        document
          .querySelector(`[data-drawer-key="${key}"]`)
          .classList.add('active');
      }
    } else {
      document
        .querySelector(`[data-drawer-key="${this.activeDrawer}"]`)
        .classList.remove('active');
    }

    this._activeDrawer = key;
  }
}

customElements.define('shopify-drawers', Drawers);